import { atom, PrimitiveAtom } from 'jotai'

import { currentEnv } from '@/env/vars.ts'
import { queryClient } from '@/QueryClient'
import { store } from '@/store'
import { IApproval, IBulkApprovalsData, ICompliance, IDropdownInfo, TIntegratedSystems, TMainSections } from '@/types/tasksApprovals'
import { GET, PUT, SIMPLE_GET } from '@/utils/fetch'

export const approvalsAtom = atom<IApproval[]>([])
export const showDetailsDrawerAtom: PrimitiveAtom<boolean> = atom<boolean>(false)

export const selectedDetailsItemAtom: PrimitiveAtom<ICompliance | IApproval> = atom<ICompliance | IApproval>(store.get(approvalsAtom)[0])

export const itemsForBulkApprovalsAtom = atom<string[]>([])
export const sailPointCertMembersMaxAtom = atom(0)
export const grpAwardAmountAtom = atom<number>(0)
export const grpCategoryAtom = atom<string>('')
export const grpCategoriesAtom = atom<IDropdownInfo>({})
export const grpAwardReasonAtom = atom('')
export const sharepointPermisionAtom = atom('view')
export const isPlusOneApprovalAtom = atom(false)
export const showSailPointCertDisclaimerAtom = atom(false)

export const getItemDetails = async <T = unknown>(systemId: TIntegratedSystems, approvalId: string, type: TMainSections) => {
    const URL = `${currentEnv.approvalsUrl}/${type}/${systemId}/${approvalId}`

    const res = await queryClient.fetchQuery({
        queryKey: [`${type}/${systemId}/${approvalId}`],
        queryFn: () => GET<T>(URL),
    })

    if (res) {
        return res
    }

    return null
}

export const getAttachement = async (
    systemId: string,
    approvalId: string,
    attachementId: string,
    fileName: string,
    type: TMainSections,
) => {
    const response = await SIMPLE_GET(`${currentEnv.approvalsUrl}/${type}/${systemId}/${approvalId}/attachments/${attachementId}`)

    if (response) {
        const blob = await response.blob()

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url

        link.download = fileName

        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)
        return true
    } else {
        return false
    }
}

export const updatesSailPointCertSelectedUsers = (items: string[], action: 'add' | 'remove') => {
    let existingUsers = [...store.get(itemsForBulkApprovalsAtom)]

    const toggleItem = (item: string) => {
        const index = existingUsers.indexOf(item)
        if (action === 'remove') {
            existingUsers = existingUsers.filter((_, idx) => idx !== index)
        } else if (action === 'add') {
            if (!existingUsers.includes(item)) existingUsers.push(item)
        }
    }

    items.map((item) => toggleItem(item))
    store.set(itemsForBulkApprovalsAtom, existingUsers)
}

export const bulkApprovals = async (
    systemId: TIntegratedSystems,
    data: IBulkApprovalsData[],
    type: TMainSections,
    hideError: boolean,
    systemParentId?: string,
) => {
    let URL = `${currentEnv.approvalsUrl}/${type}/${systemId}`
    if (systemId === 'SAP_GRC_ACCESS_REQUEST_DETAILS') {
        URL = `${currentEnv.approvalsUrl}/${type}/${systemId}/?source_system_parent_id=${systemParentId}`
    }

    return await PUT(
        URL,
        data,
        {
            'gsk-apiqw-client-id': 'GIGI_WEB',
        },
        hideError,
    )
}
